// client/src/components/volunteers/MemberVolunteering.jsx
//
// Volunteering on a member's profile (Roadmap Phase 5.2): hours, shifts
// worked, upcoming shifts. Matched by member id or email. Hidden when the
// person never volunteered, volunteers aren't set up, or the viewer's role
// can't see volunteer totals.

import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getPersonHours, formatHours } from '../../services/volunteersApi';

function day(value) {
  const d = value ? new Date(value) : null;
  return d && !Number.isNaN(d.getTime()) ? d.toLocaleDateString() : '';
}

export default function MemberVolunteering({ tenantId, memberId, email }) {
  const { t } = useTranslation();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!tenantId || (!memberId && !email)) return undefined;
    let alive = true;
    getPersonHours(tenantId, { memberId, email })
      .then((r) => { if (alive) setData(r.ready === false ? null : r); })
      .catch(() => { if (alive) setData(null); });
    return () => { alive = false; };
  }, [tenantId, memberId, email]);

  if (!data || !data.shifts || data.shifts.length === 0) return null;
  return (
    <section className="surface" data-testid="member-volunteering" style={{ marginTop: 16 }}>
      <h3 style={{ marginTop: 0 }}>{t('volunteers.member.title', 'Volunteering')}</h3>
      <p style={{ margin: '0 0 8px' }}>
        <strong>{t('volunteers.member.total', '{{hours}} in {{count}} shifts', { hours: formatHours(data.hours), count: data.shiftsWorked })}</strong>
        {data.upcoming > 0 && <> · {t('volunteers.member.upcoming', '{{count}} upcoming', { count: data.upcoming })}</>}
      </p>
      <ul style={{ margin: 0, paddingLeft: 18 }}>
        {data.shifts.slice(0, 5).map((s) => (
          <li key={s.id}>{day(s.startsAt)} · {s.role} · {s.event}{s.hours !== null && ` · ${formatHours(s.hours)}`}</li>
        ))}
      </ul>
    </section>
  );
}
